import { render } from "./CreateTaskModal.vue?vue&type=template&id=12ca60a0&scoped=true"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js"

import "./CreateTaskModal.vue?vue&type=style&index=0&id=12ca60a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ca60a0"]])

export default __exports__